import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { PurchaseMethodFlow, PurchasePriceFlow } from '../../pageFlowData'
import { purchaseMethodData } from './data'
import styles from './PurchaseMethod.module.scss'

export const PurchaseMethod: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    product: { purchaseMethod },
  } = state

  const handleTracking = (id: string) => {
    const trackingAnswer = `question | ${PurchaseMethodFlow.VIEW_NAME} | ${id}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_PURCHASE_METHOD', data: id })
    dispatch({ type: 'UPDATE_STEP', data: PurchasePriceFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: PurchasePriceFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string) => {
    handleTracking(id)
    handleDispatch(id)
  }

  const { title, image, purchaseMethodButtons } = purchaseMethodData

  return (
    <>
      <PillButtonPage
        buttons={purchaseMethodButtons}
        defaultValue={purchaseMethod}
        handleSubmit={handleSubmit}
        imgObj={{
          src: image.src,
          alt: image.alt,
        }}
        infoBoxData={purchaseMethodData}
        pillButtonGroupStyle={styles.purchaseMethodPagePillButtons}
        title={title}
      />
    </>
  )
}
